import { Box, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import PauseCircleIcon from '@mui/icons-material/PauseCircle'
import RotateRightRoundedIcon from '@mui/icons-material/RotateRightRounded'
import { type InvitationDto } from '../../../../models/peerToPeer/Invitations'
import { StatusChip } from '../../../customComponents/StatusChip'
import { tableStyles } from '../../../customComponents/dataTable/tableStyles'

const actionIcon = { fontSize: '16px', color: 'var(--grey-900)' }

const InviteeStatus = ({ status }: { status: string }): JSX.Element => status === 'Accepted'
  ? <StatusChip label='Accepted' icon={<CheckCircleRoundedIcon />} iconColor='var(--green-500)' dataTestId='p2pInviteeStatus' />
  : <StatusChip label={status} icon={<PauseCircleIcon />} iconColor='var(--orange-700)' dataTestId='p2pInviteeStatus' />

interface Props {
  invitees: InvitationDto[]
  onResend: (invitationId: number) => void
  onRevoke: (invitationId: number) => void
}

export const InviteeTable = ({ invitees, onResend, onRevoke }: Props): JSX.Element => (
  <Box sx={tableStyles.container}>
    <Table data-testid='p2pInviteeTable'>
      <TableHead>
        <TableRow>
          <TableCell sx={{ ...tableStyles.headCell, width: '260px' }}>Email</TableCell>
          <TableCell sx={{ ...tableStyles.headCell, width: '160px' }}>Status</TableCell>
          <TableCell sx={tableStyles.headCell}>Action</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {invitees.map(invitee => (
          <TableRow key={invitee.id} data-testid={`p2pInvitee-${invitee.id}`} sx={tableStyles.row}>
            <TableCell sx={{ ...tableStyles.bodyCell, color: 'var(--grey-500)', maxWidth: '260px' }} title={invitee.email}>{invitee.email}</TableCell>
            <TableCell sx={tableStyles.bodyCell}><InviteeStatus status={invitee.status} /></TableCell>
            <TableCell sx={tableStyles.bodyCell}>
              <Stack direction='row' alignItems='center' gap='10px'>
                {invitee.status !== 'Accepted' &&
                  <IconButton
                    size='small' aria-label='resend' title='Resend invitation' sx={{ p: 0 }}
                    data-testid={`p2pResendInvitee-${invitee.id}`} onClick={() => { onResend(invitee.id) }}
                  >
                    <RotateRightRoundedIcon sx={actionIcon} />
                  </IconButton>}
                <IconButton
                  size='small' aria-label='revoke' title='Remove invitation' sx={{ p: 0 }}
                  data-testid={`p2pRevokeInvitee-${invitee.id}`} onClick={() => { onRevoke(invitee.id) }}
                >
                  <DeleteRoundedIcon sx={actionIcon} />
                </IconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
)
